import React, { useEffect, useState } from "react";
import { verifyPasswordResetCode } from "firebase/auth";
import { Segment } from "semantic-ui-react";
import ChangePasswordForm from "./ChangePasswordForm";

export default function PasswordResetHandler({ auth, actionCode }) {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    if (email !== null) return;

    async function verifyEmail() {
      return verifyPasswordResetCode(auth, actionCode);
    }

    setIsLoading(true);
    verifyEmail()
      .then((userEmail) => {
        setEmail(userEmail);
      })
      .catch(() => setEmail(""))
      .finally(() => setIsLoading(false));
  }, [actionCode, auth, email]);

  return (
    <Segment loading={isLoading} padded={true}>
      {email !== "" && (
        <>
          <div className="body-blue-text">
            <span className={"semi-bold"}>Email: </span>
            <span>{email}</span>
          </div>
          <ChangePasswordForm auth={auth} actionCode={actionCode} />
        </>
      )}
      {email === "" && (
        <div className="h3-text">Password reset link expired</div>
      )}
    </Segment>
  );
}
